import { setInputMask } from '../../../components/views/chat/actions';

const LimitInputPESEL = {
    name: 'limitInputPESEL',
    exec: () => {
        setInputMask('PESEL');
    }
};

export default LimitInputPESEL;
